import { Injectable } from '@angular/core';
import { Job } from '../core-data-model/Job.model';
import { FoldersDataService } from '../core-services/Folders.dataservice';

@Injectable({
    providedIn: 'root'
})
export class JobFactory {
    constructor(private folderService: FoldersDataService) {}
    newJob(startingValues?: Partial<Job>) {
        // Handle async folder loading
        const defaultFolder = this.folderService.defaultFolder
            ? this.folderService.defaultFolder
            : null;
        if (startingValues) {
            if (!startingValues.folder) {
                const valuesWithDefaultFolder = Object.assign(
                    {},
                    startingValues,
                    {
                        folder: defaultFolder
                    }
                );
                return new Job(valuesWithDefaultFolder);
            }
            return new Job(startingValues);
        }
        return new Job({
            folder: defaultFolder
        });
    }
}
